const safeJsonParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const normalizeBase64 = (value) => {
  if (!value) return null;
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = `${value}${padding}`.replace(/-/g, '+').replace(/_/g, '/');
  return base64;
};

const decodeSegment = (segment) => {
  const normalized = normalizeBase64(segment);
  if (!normalized) return null;
  if (typeof window !== 'undefined' && typeof window.atob === 'function') {
    try {
      return window.atob(normalized);
    } catch {
      return null;
    }
  }
  const BufferCtor = typeof globalThis !== 'undefined' ? globalThis.Buffer : undefined;
  if (typeof BufferCtor !== 'undefined' && typeof BufferCtor.from === 'function') {
    try {
      return BufferCtor.from(normalized, 'base64').toString('utf-8');
    } catch {
      return null;
    }
  }
  return null;
};

export const TOKEN_EXPIRY_GRACE_MS = 45 * 1000;

export function getTokenExpiration(token) {
  if (!token) return null;
  const segments = token.split('.');
  if (segments.length < 2) return null;
  const payload = decodeSegment(segments[1]);
  if (!payload) return null;
  const parsed = safeJsonParse(payload);
  if (!parsed) return null;
  const exp = parsed.exp;
  if (typeof exp === 'number' && Number.isFinite(exp)) {
    return exp * 1000;
  }
  if (typeof exp === 'string') {
    const parsedNumber = Number(exp);
    if (Number.isFinite(parsedNumber)) {
      return parsedNumber * 1000;
    }
  }
  if (parsed.exp instanceof Date) {
    return parsed.exp.getTime();
  }
  return null;
}
